
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWifiIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 12.667a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM8 6.333a6.248 6.248 0 0 0-4.292 1.709.81.81 0 0 0 0 1.175.892.892 0 0 0 1.222 0A4.424 4.424 0 0 1 8 7.993c1.15 0 2.255.44 3.068 1.224.16.157.378.247.607.25.36.02.695-.177.842-.494a.81.81 0 0 0-.183-.931 6.25 6.25 0 0 0-4.335-1.709Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 3c-2.529.006-4.952.97-6.745 2.683a.814.814 0 0 0 0 1.184.895.895 0 0 0 1.23 0c3.047-2.925 7.982-2.925 11.028 0a.885.885 0 0 0 .615.241.885.885 0 0 0 .616-.241.818.818 0 0 0 .256-.592.818.818 0 0 0-.256-.592C12.95 3.971 10.527 3.006 7.999 3Z",
  fill: "#000"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 16 16\" fill=\"none\">\r\n<path d=\"M8 12.6667C7.17157 12.6667 6.5 11.9951 6.5 11.1667C6.5 10.3382 7.17157 9.66666 8 9.66666C8.82843 9.66666 9.5 10.3382 9.5 11.1667C9.5 11.9951 8.82843 12.6667 8 12.6667Z\" fill=\"black\"/>\r\n<path d=\"M7.99919 6.33332C6.3909 6.33865 4.84943 6.95233 3.70814 8.04165C3.37203 8.36669 3.37203 8.89162 3.70814 9.21665C4.04625 9.53976 4.59232 9.53976 4.93044 9.21665C5.74361 8.43297 6.84774 7.99254 7.99919 7.99254C9.15064 7.99254 10.2548 8.43297 11.0679 9.21665C11.228 9.37367 11.4461 9.46352 11.6748 9.46665C12.0349 9.48658 12.3702 9.29003 12.5167 8.97315C12.6632 8.65626 12.5903 8.28527 12.3336 8.04165C11.1816 6.94216 9.62249 6.32765 7.99919 6.33332Z\" fill=\"black\"/>\r\n<path d=\"M7.99926 3C5.47143 3.00646 3.04815 3.9706 1.25494 5.68333C0.915019 6.0101 0.915019 6.5399 1.25494 6.86667C1.59486 7.19344 2.14599 7.19344 2.48591 6.86667C5.53196 3.94213 10.4666 3.94213 13.5126 6.86667C13.6762 7.02266 13.8977 7.10961 14.1281 7.10833C14.3585 7.10961 14.58 7.02266 14.7436 6.86667C14.9077 6.71019 15 6.4972 15 6.275C15 6.0528 14.9077 5.83981 14.7436 5.68333C12.9504 3.9706 10.5271 3.00646 7.99926 3Z\" fill=\"black\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/wifi-icon.727eac14621670a0cd0601bb0308cedd.svg"),
        {
          React: SvgWifiIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      